import { createIcon } from '@chakra-ui/react';

export const IconShield = createIcon({
  displayName: 'IconShield',
  viewBox: '0 0 40 40',
  defaultProps: {
    height: '40px',
    width: '40px',
  },
  path: (
    <g fill="none">
      <path
        d="M23.9824 8.99023C23.9993 15.1588 24.1829 20.0549 22.875 24.1133C21.5869 28.1103 18.8089 31.3496 12.5 33.9209C6.19107 31.3496 3.41313 28.1102 2.125 24.1133C0.81713 20.0549 0.999742 15.1588 1.0166 8.99023L12.5 6.03223L23.9824 8.99023Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </g>
  ),
});
